import { Col, Form, Input, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
interface Props {
  listDetail: any;
  onchange: any;
}

const { TextArea } = Input;

const CommentDeliveryUpdate = ({ listDetail, onchange }: Props) => {
  const [selectUse, setSelectUse] = useState(true);
  const [form] = Form.useForm();
  const mapProductComment: any = listDetail;

  const packageMethod = [
    'Unnecessary',
    'Carton box',
    'Poly mailer',
    'Bubble mailer',
    'Compression',
    'Airpack',
    'Icepack',
    'Envelope',
    'Bubble wrap'
  ];

  useEffect(() => {
    let packageMethodUse = mapProductComment?.packagingMethod ?? '';

    let isNotDirectInput = packageMethodUse
        .split(',')
        .some((item: string) => packageMethod.includes(item));
    form.setFieldsValue({
      packagingMethod: !!isNotDirectInput ? mapProductComment?.packagingMethod?.split(',') : ['Directinput'],
      packageInput: !!isNotDirectInput ? '' : packageMethodUse,
      dangerous: mapProductComment.dangerous,
      shippingMethod: mapProductComment.shippingMethod,
      sellerComment: mapProductComment?.sellerComment
    });
    setSelectUse(isNotDirectInput);
  }, [listDetail]);

  return (
    <div>
      <div
        className="cmtDelivery"
        style={{ padding: '20px', borderBottom: 0, paddingBottom: 0 }}
      >
        {' '}
        <Form
          form={form}
          onFieldsChange={() => {
            const data = form.getFieldsValue();
            onchange({
              ...data,
              packagingMethod:
                data?.packagingMethod === 'Directinput'
                  ? data?.packageInput
                  : (Array.isArray(data?.packagingMethod)
                      ? data?.packagingMethod
                      : [data?.packagingMethod]
                    ).join(',')
            });
          }}
          layout="vertical"
        >
          <Row className="rowDeliver">
            <Col span={4}>
              <div>
                <Form.Item label="Packing Method" name="packagingMethod">
                  <Select
                    mode="multiple"
                    showArrow
                    placeholder="Select"
                    getPopupContainer={(node) => node}
                    onChange={(e: any) => {
                      if (e.includes('Directinput')) {
                        form.setFieldsValue({
                          packagingMethod: 'Directinput'
                        });
                        setSelectUse(false);
                      } else {
                        setSelectUse(true);
                      }
                    }}
                  >
                    {!!selectUse ? (
                      <>
                        <Select.Option value="Unnecessary">
                          Unnecessary
                        </Select.Option>
                        <Select.Option value="Carton box">
                          {' '}
                          Carton box
                        </Select.Option>
                        <Select.Option value="Poly mailer">
                          Poly mailer{' '}
                        </Select.Option>
                        <Select.Option value="Bubble mailer">
                          {' '}
                          Bubble mailer
                        </Select.Option>
                        <Select.Option value="Compression">
                          Compression
                        </Select.Option>
                        <Select.Option value="Airpack">Airpack</Select.Option>
                        <Select.Option value="Icepack">Icepack</Select.Option>
                        <Select.Option value="Envelope">Envelope</Select.Option>
                        <Select.Option value="Bubble wrap">
                          Bubble wrap
                        </Select.Option>
                        <Select.Option value="Directinput">
                          Direct input{' '}
                        </Select.Option>
                      </>
                    ) : (
                      <Select.Option value="Directinput">
                        Direct input{' '}
                      </Select.Option>
                    )}
                  </Select>
                </Form.Item>
                {!selectUse && (
                  <Form.Item
                    name="packageInput"
                    style={{ padding: '0.25rem 2.125rem 0 0' }}
                  >
                    <Input />
                  </Form.Item>
                )}
              </div>
            </Col>

            <Col span={4}>
              <Form.Item label="Dangerous Goods" name="dangerous">
                <Select
                  placeholder="Select"
                  getPopupContainer={(node) => node}
                  className="cus-select"
                >
                  <Select.Option value="0">No</Select.Option>
                  <Select.Option value="1">Yes</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Shipping Method" name="shippingMethod">
                <Select
                  placeholder="Select"
                  getPopupContainer={(node) => node}
                  className="cus-select"
                >
                  <Select.Option value="Economic">Economic</Select.Option>
                  <Select.Option value="Standard">Standard</Select.Option>
                  <Select.Option value="Express">Express</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>{' '}
          <Col span={24}>
            <div className="commentDelivery color-black">
              <p>Comment from Seller</p>
              <Form.Item name="sellerComment">
                <Input.TextArea style={{ resize: 'none' }} cols={4} />
              </Form.Item>
            </div>
          </Col>
        </Form>
      </div>
    </div>
  );
};

export default CommentDeliveryUpdate;
